import React, {useState, useRef} from 'react';
import {useIntl} from 'react-intl';
import classnames from 'classnames';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import styles from './styles.module.scss';
import inputStyles from '../../styles/commonInput.module.scss';

const CACHE = {};

const FieldInputTypeahead = ({
                               fieldId,
                               onChange,
                               setFieldValue,
                               ...rest
                             }) => {
  const handleChange = ([selected]) => {
    if (onChange) {
      onChange(selected);
    }
    setFieldValue(fieldId, '');
  };

  const handleInputChange = (e, id, inputProps) => {
    setFieldValue(id, e.target.value);
    inputProps.onChange(e);
  };

  return (
    <InputTypeahead
      id={fieldId}
      onChange={handleChange}
      onInputChange={handleInputChange}
      {...rest}
    />
  );
};

export const InputTypeahead = ({
                                 id,
                                 value,
                                 label = null,
                                 containerCustomStyles = null,
                                 labelCustomStyles = '',
                                 inputCustomStyles = null,
                                 onChange,
                                 onInputChange,
                                 readonly,
                                 makeAndHandleRequest,
                                 renderMenuItemChildren,
                                 labelKey,
                                 handleFindItem,
                                 placeholder = '',
                                 ...rest
                               }) => {
  const intl = useIntl();
  const [options, setOptions] = useState([]);
  const typeaheadRef = useRef(null);

  const handleSearch = (query) => {
    if (CACHE[query]) {
      setOptions(CACHE[query].options);
      return;
    }
    handleFindItem(query)
      .then((resp) => {
        setOptions(resp.options);
      });
  };

  return (
    <AsyncTypeahead
      id={id}
      ref={typeaheadRef}
      onSearch={handleSearch}
      onChange={e => {
        onChange(e);
        if (typeaheadRef.current) {
          typeaheadRef.current.clear();
        }
      }}
      filterBy={() => true}
      options={options}
      paginate={false}
      labelKey={labelKey}
      emptyLabel={intl.formatMessage({id: 'typeahead-search-empty-label', defaultMessage: 'Empty'})}
      searchText={intl.formatMessage({id: 'typeahead-search-text', defaultMessage: 'Search'})}
      promptText={intl.formatMessage({id: 'typeahead-prompt', defaultMessage: 'Type'})}
      renderInput={({inputRef, referenceElementRef, className, ...inputProps}) => (
        <div className={classnames(styles.inputContainer, containerCustomStyles)}>
          <div className={classnames(styles.labelContainer, labelCustomStyles)}>{label}</div>
          <input
            dir={'ltr'}
            id={id}
            name={id}
            value={value}
            placeholder={placeholder}
            className={classnames(inputStyles.input,`text-left`, inputCustomStyles)}
            type={'text'}
            ref={(input) => {
              inputRef(input);
              referenceElementRef(input);
            }}
            onChange={onInputChange}
            {...inputProps}
          />
        </div>
      )}
      renderMenuItemChildren={renderMenuItemChildren}
      useCache={false}
      {...rest}
    />
  );
};

export default FieldInputTypeahead;
